import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/shared/components/ui/Button';
import { ROUTES } from '@/routes/paths';

export function UnauthorizedPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-10 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full border border-warning/20 bg-warning/10 text-warning-text">
        <ShieldAlert className="h-6 w-6" aria-hidden />
      </div>
      <div>
        <h1 className="text-display-sm font-bold text-on-surface">Access restricted</h1>
        <p className="mt-1 text-body-md text-on-surface-variant">
          You don't have permission to view this page.
        </p>
        <p className="mt-1 text-body-sm text-on-surface-subtle">
          Screen access is granted per role. Ask an administrator to enable it under Roles &amp; Permissions.
        </p>
      </div>
      <Link to={ROUTES.dashboard}>
        <Button variant="outline">Back to dashboard</Button>
      </Link>
    </div>
  );
}
